"use client";

import { useEffect, useState } from "react";

/**
 * Le nombre de comptes, pour un composant qui tourne dans le navigateur.
 *
 * UNE VALEUR FIGÉE D'ABORD, LE COMPTE RÉEL ENSUITE. NUMBER_OF_STUDENTS est
 * arrondie et vieillit entre deux déploiements, mais elle a un mérite : elle
 * est disponible au premier rendu, donc le serveur et le navigateur affichent
 * la même chose et l'hydratation ne se plaint pas. Le compte réel la remplace
 * dès qu'il arrive, sans que rien clignote : les deux nombres se ressemblent.
 *
 * UN ÉCHEC NE SE VOIT PAS. Si le relais ne répond pas, la valeur figée reste,
 * et la phrase garde son « plus de » : elle est alors une estimation basse,
 * ce qu'elle a toujours été.
 */
export default function useCommunityCount() {
    const figee = Number(process.env.NUMBER_OF_STUDENTS) || null;
    const [nombre, setNombre] = useState(null);

    useEffect(() => {
        let vivant = true;
        fetch("/api/community-count")
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => {
                if (vivant && d && Number.isFinite(d.count) && d.count > 0) {
                    setNombre(d.count);
                }
            })
            .catch(() => {
                // La valeur figée fait l'affaire.
            });
        return () => {
            vivant = false;
        };
    }, []);

    return {
        // Ce qu'il faut afficher, maintenant.
        nombre: nombre || figee,
        // Vrai quand le compte vient du back : la phrase peut alors perdre son
        // « plus de », puisqu'elle n'approxime plus.
        exact: Boolean(nombre),
    };
}
